import { useParams } from "react-router";
import { Loading } from "./Loading";
import { NotFound } from "./NotFound";
import { useContent } from "../../hooks/useContent";
import { ArticlePage } from "./ArticlePage";
import { GetArticlePageBySlug } from "../../queries/GetArticlePageBySlug";
import { ArticleModal } from "./ArticleModal";

export const ArticlePageResolver = ({
  modal,
}: {
  modal?: { slug: string; open: boolean };
}) => {
  // if no slug, we are on the index route, pull homepage
  const { slug } = useParams();

  const [response] = useContent({
    query: GetArticlePageBySlug,
    variables: { slug: modal?.slug ?? slug },
  });

  if (response.fetching && !modal) {
    return <Loading />;
  }

  const [articlePage] = response.data?.articlePageCollection?.items ?? [];

  if ((!response.data || !slug || !articlePage) && !modal) {
    return <NotFound />;
  }

  if (modal) {
    return (
      <ArticleModal key={slug} articlePage={articlePage} open={modal.open} />
    );
  }

  return <ArticlePage key={slug} articlePage={articlePage!} />;
};
